export function isMobile(): boolean {
  return window.innerWidth <= 600;
}

export function isTablet(): boolean {
  return window.innerWidth <= 1264;
}
